import * as actionTypes from "./actionTypes"

export function changeTheme(theme: string) {
    const action: ThemeAction = {
        type: actionTypes.CHANGE_THEME,
        theme,
    }
    return action
}